import React from "react";
import { Attachment } from "../..";
import styles from "./chat-photo.module.scss";

const ChatPhoto = ({ image }: { image: Attachment }) => (
  <a className={styles.imageLink} href={image.link} target="_blank">
    <img
      alt="Image Attachment"
      className={styles.image}
      src={image.link}
      width="280px"
      height="280px"
    />
  </a>
);

export default ChatPhoto;
